import { useState, type ReactNode } from 'react';
import { Box, Divider, Drawer, IconButton, useTheme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import useTranslation from 'canvas_states/translation/useTranslation';

export interface HamburgerMenuProps {
  children: ReactNode;
}

export const dataTestId = {
  openIcon: 'openIcon',
  closeIcon: 'closeIcon',
  wrapper: 'wrapper',
};

const HamburgerMenu = ({ children }: HamburgerMenuProps) => {
  const [open, setOpen] = useState(false);

  const handleHamburgerMenuClick = () => {
    setOpen(!open);
  };

  const { t } = useTranslation().actions;
  const theme = useTheme();
  return (
    <>
      <IconButton aria-label={t('offer.header.menu')} color="inherit" onClick={handleHamburgerMenuClick}>
        <MenuIcon data-testid={dataTestId.openIcon} sx={{ color: theme?.partner?.header?.hamburgerMenuColor }} />
      </IconButton>
      <Drawer
        open={open}
        onClose={handleHamburgerMenuClick}
        data-testid={dataTestId.wrapper}
        anchor={theme.direction === 'rtl' ? 'right' : 'left'}
      >
        <Box p={1}>
          <IconButton color="inherit" onClick={handleHamburgerMenuClick}>
            <CloseIcon data-testid={dataTestId.closeIcon} />
          </IconButton>
        </Box>
        <Divider />
        <Box p={2.5} minWidth={250}>
          {children}
        </Box>
      </Drawer>
    </>
  );
};
export default HamburgerMenu;
